import React, {Component} from 'react'
import { Waypoint } from 'react-waypoint'

import Player from '../Player/Player'
import Expander from '../Expander/Expander'
import Lock from '../Lock/Lock'

import './styles.scss'

class ChapterOne extends Component {  
    constructor(props) {
        super(props);
        this.state = { width: 0, height: 0 };
        this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
    }
        
    componentWillUnmount() {
        window.removeEventListener('resize', this.updateWindowDimensions);
    }
        
    updateWindowDimensions() {
        this.setState({ width: window.innerWidth, height: window.innerHeight });
    }
    componentDidMount() {
        this.updateWindowDimensions();
        window.addEventListener('resize', this.updateWindowDimensions);
    }
    render () {
        return (    
            <>
                <Waypoint horizontal onEnter={()=>{this.props.chapterTransition("one")}}> 
                <div className="chapter chapter-one chapter-1" style={{height: this.state.height + "px" }}>
                    
                    <div className="scroll-container bg">
                        <div className="scroll"></div>
                    </div>
                    <div className="scroll-container mushroom">
                        <div className="scroll">
                        </div>
                    </div> 
                    <div className="scroll-container bear">
                        <div className="scroll">
                        </div>
                    </div> 
                    <div className="scroll-container bille">
                        <div className="scroll">
                        </div>
                    </div> 
                    <div className="scroll-container one">
                        <div className="white-content scroll">
                            <h2>I skogen bor det en snål skapning som heter skrukketroll.</h2>
                            <p>Skrukketrollet har to antenner, fjorten bein og en drøss med kallenavn, for eksempel benkebiter, kaffebille og tusselus. Skrukketrollet er det eneste krepsdyret som lever på land, men det rareste med skrukketrollet er at du kan ha noe til felles med det. Skrukketrollet trives best når det er rotete!</p>
                        </div>
                        <Player file="1_1" />
                    </div>
                    <div className="scroll-container two">
                        <div className="white-content scroll">
                            <p>Forskjellen mellom deg og skrukketrollet, i tillegg til at du har to bein og ikke fjorten, er at det ikke er noen som maser om at skrukketrollet må rydde.</p>
                            <h2>Artene som lever i skogen er enige om at rot er rått! </h2>
                        </div>
                        <Player file="1_2" />
                    </div>   
                    <div className="scroll-container three">
                        <div className="white-content scroll">
                            <p>Alle artene som bor i skogen har sine favorittrær, favorittplanter, favorittmat og favorittgjemmesteder. Noen har flere favoritter, mens andre er veldig kresne. I skoger med mye rot er det masse å velge mellom, og derfor er det veldig mange som liker seg ekstra godt her.</p>
                        </div>
                        <Player file="1_3" />
                    </div>   
                    <div className="scroll-container four">
                        <div className="white-content scroll">
                            <h2>Det er i roteskogen vi finner de sære og spennende artene, for her finner de akkurat det de trenger for å trives.</h2>
                            <p>Hakkespetten liker morkne trær, og bjørnen elsker blåbær. Andre arter må du se godt etter for å finne. Skrukketrollet er på størrelse med lillefingerneglen til lillesøster!</p>
                        </div>
                        <Player file="1_4" />
                    </div> 
                    <div className="scroll-container five">
                        <div className="white-content scroll">
                            <h2>Grunnen til at gamle skoger ofte er rotete, er at trærne får lov til å leve til de dør av seg selv.</h2>
                            <p>Det kan ta 500 til 1000 år. Først står trærne døde i mange år, før de faller over ende med et brak. De største trærne kan gjøre så bakken rister, nesten som det er jordskjelv. </p>
                            <h2>Varsko her!</h2>
                        </div>
                        <Player file="1_5" />
                    </div>
                    <div className="scroll-container six">
                        <div className="white-content scroll">
                            <p>Trærne blir liggende på bakken til de går i oppløsning, og det kan også ta veldig lang tid.</p>
                            <h2>Der det gamle treet pleide å stå spirer nye trær og overtar den ledige plassen, og vi får en skog med trær i alle aldre.</h2>
                            <p>Det er et rot, men det er et fint og spennende rot.</p>
                        </div>
                        <Player file="1_6" />
                    </div>
                    <div className="scroll-container woodpecker">
                        <div className="scroll">
                        </div>
                    </div> 
                    <div className="thank-you">Takk for at du skyller, bretter og stapper skolemelka for skrokketrollet!</div>
                    <Expander
                        class="expander-one"
                        content="Finner du fram forstørrelsesglasset kan du oppdage smarte flueblomster som later som de er hunnvepser for å få hannvepsene til å spre pollen over seg."
                        chapter='1'
                    ></Expander>
                    <Lock 
                        progress="two"
                        handleModal={this.props.handleModal}
                        >
                    </Lock>
                </div>
                </Waypoint>
            </>
        )

    }
}

export default ChapterOne

